<odl-menu [attr.for]="menuFor()" placement="top-start">
  <odl-menu-item (odl-select)="addQuestion(false)">
    <odl-icon name="question" slot="icon"></odl-icon>
    <span>{{ 'ADMIN_ACTIONS.ADD_QUESTION' | translate | titlecase }}</span>

    @if (canUseAi()) {
      <odl-menu-item slot="submenu" (odl-select)="addQuestion(true); $event.stopPropagation()">
        <odl-icon name="ai" slot="icon"></odl-icon>
        <span>{{ 'TEXT_SELECTION.WITH_AI' | translate }}</span>
      </odl-menu-item>

      <odl-menu-item slot="submenu" (odl-select)="addQuestion(false); $event.stopPropagation()">
        <odl-icon name="add" slot="icon"></odl-icon>
        <span>{{ 'TEXT_SELECTION.MANUALLY' | translate }}</span>
      </odl-menu-item>
    }
  </odl-menu-item>

  <odl-menu-item (odl-select)="addQuiz(false)">
    <odl-icon name="quiz" slot="icon"></odl-icon>
    <span>{{ 'ADMIN_ACTIONS.ADD_QUIZ' | translate | titlecase }}</span>

    @if (canUseAi()) {
      <odl-menu-item slot="submenu" (odl-select)="addQuiz(true); $event.stopPropagation()">
        <odl-icon name="ai" slot="icon"></odl-icon>
        <span>{{ 'TEXT_SELECTION.WITH_AI' | translate }}</span>
      </odl-menu-item>

      <odl-menu-item slot="submenu" (odl-select)="addQuiz(false); $event.stopPropagation()">
        <odl-icon name="add" slot="icon"></odl-icon>
        <span>{{ 'TEXT_SELECTION.MANUALLY' | translate }}</span>
      </odl-menu-item>
    }
  </odl-menu-item>

  <odl-menu-item (odl-select)="addNote()">
    <odl-icon name="sticky_note" slot="icon"></odl-icon>
    <span>{{ 'ADMIN_ACTIONS.ADD_NOTE' | translate | titlecase }}</span>
  </odl-menu-item>
</odl-menu>
